import { useEffect, useState } from 'react';
import { Checkbox, Typography } from '@mui/material';
import SearchAndSortableTable from '../../../../../components/table/SearchAndSortableTable';
import {
  useGetSelectedTeacherTable,
  useHandleSearchDistrictSchoolSelector,
  validateMoveTeacherFormData as validator,
} from './MoveTeacherActionHooks';
import './MoveTeacherForm.scss';
import DistrictSchoolSelector from '../district-school-selector/DistrictSchoolSelector';
import { filterUndefined } from '../../../../../utils/FilterUndefinedObject';

export const validateMoveTeacherFormData = validator;

const defaultProps = {
  initData: {
    shouldMoveStudent: false,
    schoolId: null,
  },
  teacherTableData: [],
  onDataChange: () => null,
};
const MoveTeacherForm = (props) => {
  const { initData, teacherTableData, onDataChange } = { ...defaultProps, ...filterUndefined(props) };
  const {
    tableConfig,
    tableData,
  } = useGetSelectedTeacherTable({
    teacherTableData,
  });

  const [data, setData] = useState({ ...initData });

  useEffect(() => {
    setData({ ...initData });
  }, [initData]);

  const {
    handleOnDistrictSchoolChange,
  } = useHandleSearchDistrictSchoolSelector({
    data,
    setData,
    onDataChange,
  });

  return (
    <div className='move-teacher-form'>
      <SearchAndSortableTable
        containerClassName='move-teacher-table'
        config={tableConfig}
        tableData={tableData}
        initTableState={{
          order: 'desc',
          orderBy: 'userName',
        }}
        autoResetTableState
        filterable={false}
        rowsPerPageOptions={[5, 10, 25, 50]}
      />

      <div className='form-row'>
        <Typography className='form-label'>
          Move Students
        </Typography>
        <Checkbox
          checked={data.shouldMoveStudent}
          onChange={(e) => {
            const updatedData = {
              ...data,
              shouldMoveStudent: e.target.checked,
            };
            setData(updatedData);
            onDataChange(updatedData, validateMoveTeacherFormData(updatedData));
          }}
          name='shouldMoveStudent'
          className='move-student-checkbox'
          inputProps={{
            'aria-label': 'Move Students',
          }}
        />
      </div>

      <DistrictSchoolSelector
        onChange={handleOnDistrictSchoolChange}
        selectedDistrictId={data.district && data.district.key}
        selectedSchoolId={data.school && data.school.key}
      />
    </div>
  );
};

export default MoveTeacherForm;
